import { ChatAgent } from './EnumsAI.enum';

export interface IChatIASamantha {
	assistantResponse: string;
	percentage: {
		percentage: number;
		pendingFields: string[];
	};
	onboardingId: number;
}

export interface IAssistantResponse {
	rfc: string | null;
	regimes_codes: number[];
	economic_activities: string;
	economic_activities_detail: string;
	average_income: string;
	has_presented_taxes: string;
	has_sat_portal_signature: string;
	has_sat_portal_password: string;
	user_needs: string[];
	source_channel: string;
	assistant_feedback_question: string;
}

export interface IUsage {
	inputTokens: number;
	outputTokens: number;
	totalTokens: number;
}

export interface IUserCurrentData {
	id: number;
	user_id: number;
	rfc: string | null;
	regimes_codes: string | number[];
	economic_activities: string;
	economic_activities_detail: string;
	average_income: string;
	has_presented_taxes: string;
	has_sat_portal_signature: string;
	has_sat_portal_password: string;
	user_needs: string;
	source_channel: string;
	created_at: string;
	updated_at: string;
	thread: IMessage[];
	assistant_latest_question: string;
}

export interface IMessage {
	role: 'assistant' | 'user';
	content: string;
}

export interface IOnboardingResponseSamantha {
	userCurrentData: IUserCurrentData;
	percentage: {
		percentage: number;
		pendingFields: string[];
	};
	onboardingId: number;
}

export interface OnboardingAnalysis {
	name: string;
	slug: string;
	benefits: string;
	description: string;
	heruBenefits: OnboardingBenefits;
	introduction: string;
	regimesCodes: any[];
	regimesNames: any[];
	regimeBenefits: OnboardingBenefits;
	regimesSummary: OnboardingRegimesSummary;
	regimesFFT: any[];
}

export interface OnboardingBenefits {
	summary: string;
	bulletPoints: HeruBenefitsBulletPoint[];
}

export interface HeruBenefitsBulletPoint {
	title: string;
	description: string;
}

export interface OnboardingRegimesSummary {
	bulletPoints: RegimesSummaryBulletPoint[];
	regimesDescription: string;
}

export interface RegimesSummaryBulletPoint {
	content: string;
}

// Chat AI
export type Tool = {
	name: string;
	args: Record<string, any>;
};

export type ChatMessage = {
	role: 'assistant' | 'user';
	content: string;
	tools?: Tool[];
	uuid?: string;
	toolsExecuted?: string[];
	additionalInfo?: {
		orchestratorOutput?: string;
	};
};

export enum SchemaType {
	STRING = 'STRING',
	NUMBER = 'NUMBER',
	INTEGER = 'INTEGER',
	BOOLEAN = 'BOOLEAN',
	ARRAY = 'ARRAY',
	OBJECT = 'OBJECT',
}

export type ToolVertex = {
	agentName: ChatAgent;
	name: string;
	description: string;
	parameters: {
		type: SchemaType;
		properties: {
			[key: string]: {
				type: SchemaType;
				description: string;
				enum?: string[];
			};
		};
		required: string[];
	};
};

export interface Conversation {
	id: number;
	user_id: number;
	thread: ChatMessage[];
	created_at: Date;
	updated_at: Date;
}
